import { ActionContext } from "vuex";
import JSConfetti from "js-confetti";

class UtilsState {
  /** Tells whether the loading screen is visible or not. */
  isLoading = false;

  /** Tells whether the loading screen is visible or not. */
  isContentLoading = false;

  /** Message that displays at the loading screen. */
  message = "";

  /** Message that displays at the loading screen. */
  contentLoadingMessage = "";

  isVisible = false;
}

const state = new UtilsState();

const mutations = {
  SET_LOADING_VISIBILITY(state: UtilsState, isLoading: boolean): void {
    state.isLoading = isLoading;
  },
  SET_CONTENT_LOADING_VISIBILITY(
    state: UtilsState,
    isContentLoading: boolean
  ): void {
    state.isContentLoading = isContentLoading;
  },
  SET_MESSAGE(state: UtilsState, message: string): void {
    state.message = message;
  },
  SET_CONTENT_MESSAGE(state: UtilsState, contentLoadingMessage: string): void {
    state.contentLoadingMessage = contentLoadingMessage;
  },
  SET_VISIBILITY(state: UtilsState, isVisible: boolean): void {
    state.isVisible = isVisible;
  }
};

const actions = {
  /** Action used to set the loading screen visibility.
   * @param commit
   * @param isLoading Tells whether the loading screen will be visible or hidden. */
  setLoadingVisibility(
    { commit }: ActionContext<UtilsState, UtilsState>,
    isLoading: boolean
  ): void {
    commit("SET_LOADING_VISIBILITY", isLoading);
  },
  /** Action used to set the loading screen visibility.
   * @param commit
   * @param isContentLoading Tells whether the loading screen will be visible or hidden. */
  setContentLoadingVisibility(
    { commit }: ActionContext<UtilsState, UtilsState>,
    isContentLoading: boolean
  ): void {
    commit("SET_CONTENT_LOADING_VISIBILITY", isContentLoading);
  },
  /** Action used set the message of the current loading screen.
   * @param commit
   * @param message Message that will be given to the loading screen. */
  setMessage(
    { commit }: ActionContext<UtilsState, UtilsState>,
    message: string
  ): void {
    commit("SET_MESSAGE", message);
  },
  /** Action used set the message of the current loading screen.
   * @param commit
   * @param message Message that will be given to the loading screen. */
  setContentLoadingMessage(
    { commit }: ActionContext<UtilsState, UtilsState>,
    contentLoadingMessage: string
  ): void {
    commit("SET_CONTENT_MESSAGE", contentLoadingMessage);
  },

  setVisibility(
    { commit }: ActionContext<UtilsState, UtilsState>,
    isVisible: boolean
  ): void {
    commit("SET_VISIBILITY", isVisible);
  }
};

const getters = {
  isLoading: (state: UtilsState): boolean => state.isLoading,
  isVisible: (state: UtilsState): boolean => state.isVisible,

  isContentLoading: (state: UtilsState): boolean => state.isContentLoading,
  message: (state: UtilsState): string => state.message
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
